import { AxiosInstance } from 'axios';
import {
  OrderEndpoint,
  GetOrderRequest,
  GetOrdersRequest,
  GetOrdersResponse,
} from './OrderServices.types';

export class OrderSevices implements OrderEndpoint {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  getById(request: GetOrderRequest) {
    return this.instance.get(`/order/${request.routeParams.orderGuid}`);
  }

  getOrders(request: GetOrdersRequest) {
    return this.instance.post<GetOrdersResponse>('/orders/list', request.body, {
      params: request.queryParams,
    });
  }
}
